import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { userInfo } from 'src/app/constants/constants';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-common-user-info',
  templateUrl: './common-user-info.component.html',
  styleUrls: ['./common-user-info.component.scss'],
})
export class CommonUserInfoComponent implements OnInit {
  @Input() isCollapse: any;

  userInfo: userInfo = {
    name: '',
    courses: ['Test Prep', 'Grade 9'],
    ppic: 'assets/images/dashboard/user-ppic.svg',
  };

  userNameSubscription: Subscription;

  constructor(private commonService: CommonService) {
    this.userNameSubscription = this.commonService
      .getUserName()
      .subscribe((name) => {
        this.userInfo.name = name;
        console.log(this.userInfo);
      });
  }

  ngOnInit(): void {}
}
